<template>
  <div>
    <div class="card-columns">
        <div class="card" v-bind:key="schedule" v-for="schedule of latestRuns">
            <div class="card-img-top-box">
            <img class="card-img-top" v-if="schedule.topImage" :src="schedule.topImage.img" :alt="schedule.topImage.name">
            </div>
            <div class="card-body">
                <router-link v-bind:to="'/job/edit/' + schedule.scheduleId">
                  <h5 class="card-title">{{schedule.name}}</h5>
                </router-link>
                <div class="card-text" v-bind:key="item" v-for="item of schedule.fragments">
                    <p v-if="item.value"><b>{{item.name}}:</b> {{item.value}}</p>
                    <p v-if="item.img"><b>{{item.name}}:</b> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-card-image" viewBox="0 0 16 16">
  <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
  <path d="M1.5 2A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13zm13 1a.5.5 0 0 1 .5.5v6l-3.775-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12v.54A.505.505 0 0 1 1 12.5v-9a.5.5 0 0 1 .5-.5h13z"/>
</svg></p>
                    <p v-if="item.error"><b>{{item.name}}:</b> ERROR: {{item.error}}</p>
                </div>
                <p class="card-text">
                    <span v-if="schedule.status == 'SUCCESS'" class="badge badge-pill badge-success">success</span>
                    <span v-if="schedule.status == 'ERRORS'" class="badge badge-pill badge-warning">errors</span>
                    <span v-if="schedule.status == 'FAIL'" class="badge badge-pill badge-danger">failure</span>
                    &nbsp;&nbsp;
                    <b-link v-b-modal.job-run-result variant="link" v-on:click="loadResult(schedule.scheduleId, schedule.runId)" title="View List">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-card-list" viewBox="0 0 16 16">
                        <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"/>
                        <path d="M5 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 5 8zm0-2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-1-5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zM4 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm0 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"/>
                      </svg>
                    </b-link>
                    <br/>
                    <small class="text-muted">{{schedule.finishedTime.toLocaleDateString()}} {{schedule.finishedTime.toLocaleTimeString()}}</small>
                    <!-- &nbsp;&nbsp;&nbsp;
                    <b-link v-b-modal.job-run-result variant="link" v-on:click="loadResult(schedule.scheduleId, schedule.runId)" title="View List">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-globe2" viewBox="0 0 16 16">
                      <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm7.5-6.923c-.67.204-1.335.82-1.887 1.855-.143.268-.276.56-.395.872.705.157 1.472.257 2.282.287V1.077zM4.249 3.539c.142-.384.304-.744.481-1.078a6.7 6.7 0 0 1 .597-.933A7.01 7.01 0 0 0 3.051 3.05c.362.184.763.349 1.198.49zM3.509 7.5c.036-1.07.188-2.087.436-3.008a9.124 9.124 0 0 1-1.565-.667A6.964 6.964 0 0 0 1.018 7.5h2.49zm1.4-2.741a12.344 12.344 0 0 0-.4 2.741H7.5V5.091c-.91-.03-1.783-.145-2.591-.332zM8.5 5.09V7.5h2.99a12.342 12.342 0 0 0-.399-2.741c-.808.187-1.681.301-2.591.332zM4.51 8.5c.035.987.176 1.914.399 2.741A13.612 13.612 0 0 1 7.5 10.91V8.5H4.51zm3.99 0v2.409c.91.03 1.783.145 2.591.332.223-.827.364-1.754.4-2.741H8.5zm-3.282 3.696c.12.312.252.604.395.872.552 1.035 1.218 1.65 1.887 1.855V11.91c-.81.03-1.577.13-2.282.287zm.11 2.276a6.696 6.696 0 0 1-.598-.933 8.853 8.853 0 0 1-.481-1.079 8.38 8.38 0 0 0-1.198.49 7.01 7.01 0 0 0 2.276 1.522zm-1.383-2.964A13.36 13.36 0 0 1 3.508 8.5h-2.49a6.963 6.963 0 0 0 1.362 3.675c.47-.258.995-.482 1.565-.667zm6.728 2.964a7.009 7.009 0 0 0 2.275-1.521 8.376 8.376 0 0 0-1.197-.49 8.853 8.853 0 0 1-.481 1.078 6.688 6.688 0 0 1-.597.933zM8.5 11.909v3.014c.67-.204 1.335-.82 1.887-1.855.143-.268.276-.56.395-.872A12.63 12.63 0 0 0 8.5 11.91zm3.555-.401c.57.185 1.095.409 1.565.667A6.963 6.963 0 0 0 14.982 8.5h-2.49a13.36 13.36 0 0 1-.437 3.008zM14.982 7.5a6.963 6.963 0 0 0-1.362-3.675c-.47.258-.995.482-1.565.667.248.92.4 1.938.437 3.008h2.49zM11.27 2.461c.177.334.339.694.482 1.078a8.368 8.368 0 0 0 1.196-.49 7.01 7.01 0 0 0-2.275-1.52c.218.283.418.597.597.932zm-.488 1.343a7.765 7.765 0 0 0-.395-.872C9.835 1.897 9.17 1.282 8.5 1.077V4.09c.81-.03 1.577-.13 2.282-.287z"/>
                    </svg>
                    </b-link> -->
                </p>
            </div>
        </div>
    </div>
    <p v-if="runsLoaded && latestRuns.length == 0">There are no job runs yet.</p>
    <b-modal id="job-run-result" title="Job Run Results" size="lg" hide-footer>
      <p class="my-6"></p>
      <div v-if="runResult.length > 0">
        <table class="table">
          <thead class="thead-dark">
            <tr>
              <th>Fragment</th>
              <th>Content</th>
            </tr>
          </thead>
          <tr v-bind:key="item" v-for="item of runResult">
            <td>{{item.name}}</td>
            <td v-if="item.value"><pre>{{item.value}}</pre></td>
            <td v-else-if="item.error">ERROR: {{item.error}}</td>
            <td v-else-if="item.img"><img class="image" :src="item.img" /></td>
            <td v-else></td>
          </tr>
        </table>
      </div>
      <div v-else>{{message}}</div>
    </b-modal>
  </div>
</template>
<script>
import axios from 'axios';
import jQuery from 'jquery';
import _ from 'lodash';
import CommonMixin from '../util/common';
import AppConfig from '../util/config';

export default {
  name: 'cards',
  mixins: [CommonMixin],
  props: {
    limit: String,
    scheduleId: {
      type: String,
      default: null
    },
    mode: {
      type: String,
      default: "latest"
    }
  },
  data() {
    return {
      runResult: [],
      runLoaded: false,
      latestRuns: [],
      runsLoaded: false,
      message: ""
    }
  },
  methods: {
    getLatestSchedules() {
      var that = this;
      that.latestRuns = [];
      this.overlayOn();
      return this.backendGet("/schedule/latestRuns").then(result => {
        that.overlayOff();
        that.latestRuns = _.each(result.data, function(o) { 
            o.finishedTime = new Date(o.finishedTime * 1000);
            o.fragments = _.map(o.fragments, function(x) {
              if (x.value !== undefined) {
                var newValue = _.truncate(x.value, {'length': 256, 'separator': ' '});
                x.value = newValue;
              }
              return x;
            });
            o.topImage = _.head(_.filter(o.fragments, function(x) { return x.img !== undefined }));
        });
        that.runsLoaded = true;
      });
    },
    loadRuns(scheduleId) {
      var that = this;
      that.latestRuns = [];
      this.overlayOn();
      return this.backendGet("/schedule/runs/" + scheduleId).then(result => {
        that.overlayOff();
        that.latestRuns = _.each(result.data, function(o) { 
            o.finishedTime = new Date(o.finishedTime * 1000);
        });
        that.runsLoaded = true;
      });
    },
    loadResult(scheduleId, runId) {
      this.runLoaded = false;
      this.runResult = [];
      this.message = "Loading..."
      var that = this;
      return this.backendGet("/schedule/runs/" + scheduleId + "/" + runId).then(result => {
        that.runResult = result.data.result;
        that.runLoaded = true;
      });
    }
  },
  mounted() {
    if (this.scheduleId) {
      this.loadRuns(this.scheduleId).catch(err => {
        this.$emit("error", err);
      });
    } else {
      this.getLatestSchedules().catch(err => {
        this.$emit("error", err);
      });
    }
  },
  updated() {}
}
</script>

<style scoped>
pre {
    white-space: pre-wrap;       /* Since CSS 2.1 */
    white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
    white-space: -pre-wrap;      /* Opera 4-6 */
    white-space: -o-pre-wrap;    /* Opera 7 */
    word-wrap: break-word;       /* Internet Explorer 5.5+ */
}
.image {
  max-width: 100%;
}
.card-img-top-box {
  max-height: 300px;
  overflow-y: hidden;
}
.card-img-top {
    max-width: 100%;
}
.card-img-icon {
    width: auto;
    max-height: 25px;
}
body {
  background: #232321;
}
h1 {
  color: #fff;
  padding: 10px 0;
}
.card {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border: none;
  /* &:hover {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.4);
  }
  a {
    color: initial;
    &:hover {
      text-decoration: initial;
    }
  }
  .text-muted i {
    margin: 0 10px;
  } */
}
</style>